import { useEffect } from "react";
import './About.css';
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer"; 
import {useLocation } from "react-router-dom";
 
const About = ()=> {


   // const navigate = useNavigate();
    const location = useLocation();

       // Function to handle navigation
    //    const handleNavigation = (section) => {
    //     if (location.pathname !== "/") {
    //         navigate("/", { state: { scrollTo: section } });
    //     } else {
    //         scrollToSection(section);
    //     }
    // };

     // Function to scroll to section
     const scrollToSection = (section) => {
        setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 300);
    };

       
       useEffect(() => {
        if (location.state?.scrollTo) {
            scrollToSection(location.state.scrollTo);
        }
    }, [location]);


    return (
        <>
            <AIheader/>

            {/* START aboutBanner */}
            <section className='aboutBanner'>
                <div className='aboutBannerInner'>
                    <h1>About Us</h1>
                </div>
            </section>
            {/* END aboutBanner */}


            {/* START whereInnorMain */}
            <section className='whereInnorMain'>  
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='whereInnorInner'>
                                <h2>Innovation Meets Rental<br/> Industry Challenges</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END whereInnorMain */}
 
    
            {/* STRAT deliverSoftwareMain */}
            <section className='deliverSoftwareMain'> 
                <div className='container'>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-6">
                            <div className="deliverSoftwareLeft">
                                <h2>At Rentid, we build<br/> modern infrastructure</h2>
                                {/* <p>We solve real-world rental problems. </p> */}
                                <p>We’re a hybrid enterprise software platform and modern <br/>
                                rental marketplace, purpose-built for the car rental industry. <br/> 
                                Our approach always starts with one critical question</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="deliverSoftwareRight">
                                <h2>What’s your rental problem?</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END deliverSoftwareMain */}
 

            {/* START whetherYouMain */}
            <section className='whetherYouMain'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='whetherYouInner'>
                                <p>Whether you manage a single location or oversee a nationwide fleet, we create flexible, scalable, and reliable solutions tailored to the specific needs of today’s rental operators—be it independent entrepreneurs or established brands.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END whetherYouMain */}


            {/* STRAT bornFromMain */}
            <section className='bornFromMain'>
                <div className='container'>
                    <div className="row justify-content-center align-items-center">
                        <div className="col-lg-6">
                            <div className="bornFromLeft">
                                <figure>
                                    <img className='img-fluid' src="/img/About/rentid_green.svg" alt="Born from Industry Grit"/>
                                </figure>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="bornFromRight">
                                <h2>Born from Industry Grit</h2>
                                <p>Rentid (pronounced “ren-tid”) is more than a brand,<br/>it's our promise.</p>
                                <p>We were founded to address one of the industry’s most pressing yet 
                                overlooked challenges: trust and safety. Handing over your vehicles 
                                to unfamiliar drivers carries inherent risks that can stall bookings, 
                                inflate costs, and limit growth.</p>
                                <h3>Our first innovation?</h3>
                                <p>RentID—a powerful guest screening and identity verification system 
                                designed to proactively mitigate risk. Identification isn’t just what 
                                we do; it’s who we are. RentID became the cornerstone for creating 
                                safer transactions, boosting trust, and fueling business growth.</p>
                            </div>
                        </div>
                    </div>
                </div>        
            </section>
            {/* END bornFromMain */}

            {/* START builtByMain */}
            <section className='builtByMain'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='builtByInner'>
                                <h2>When your vehicle is "Rentid," it's <br/>
                                <span>trusted, protected, and profitable.</span></h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END builtByMain */}

            {/* STRAT builtOperatorsMain */}
            <section className='builtOperatorsMain'> 
                <div className='container'>
                <div className='builtOperatorsArea'>
                    <div className='builtOperatorsOuter'>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6">
                                <div className="builtOperatorsLeft">
                                    <h2>Built by Operators, <br/> for Operators</h2>
                                    <p>From the beginning, we set out to disrupt the industry. 
                                    Today, that disruption has evolved into community-powered 
                                    innovation, shaped by extensive real-world experience. Our 
                                    diverse team of operators, engineers, insurance specialists, 
                                    and problem-solvers collaboratively tackles the industry’s 
                                    toughest challenges.</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="builtOperatorsRight">
                                    <figure>
                                        <img className='img-fluid' src="/img/About/built_operators.webp" alt="Built by Operators"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='builtOperatorsOuter builtOperatorsOuter_2'>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6">
                                <div className="builtOperatorsRight">
                                    <figure>
                                        <img className='img-fluid' src="/img/About/built_operators_2.webp" alt="Built by Operators"/>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="builtOperatorsLeft">
                                    <p>Originally designed for small and mid-sized businesses (SMBs) looking 
                                    for competitive edge and growth, Rentid now also serves enterprise 
                                    clients facing complex, scalable challenges. What connects us all? 
                                    A shared commitment to advancing the rental industry with smarter 
                                    tools and greater control.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </section>
            {/* END builtOperatorsMain */}

            {/* START rentalRevoMain */}
            <section className="rentalRevoMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="rentalRevoHead">
                                <h2>The Rental Revolution Starts Here</h2>
                                <p>Our users share more than our technology—they share our vision:</p>
                            </div>
                        </div>
                    </div>


                    <div className="row justify-content-center">
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <div className="rentalRevoDetail">
                                <figure>
                                    <img className='img-fluid' src="/img/About/shield_icon.svg" alt="icon"/>
                                </figure>
                                <h3>Trust-first<br/> innovation</h3>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <div className="rentalRevoDetail">
                                <figure>
                                    <img className='img-fluid' src="/img/About/shield_icon.svg" alt="icon"/>
                                </figure>
                                <h3>Scalable, adaptable<br/> infrastructure</h3>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <div className="rentalRevoDetail">
                                <figure>
                                    <img className='img-fluid' src="/img/About/math_icon.svg" alt="icon"/>
                                </figure>
                                <h3>Full control over<br/> branding and bookings</h3>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                            <div className="rentalRevoDetail">
                                <figure>
                                    <img className='img-fluid' src="/img/About/shield_icon.svg" alt="icon"/>
                                </figure>
                                <h3>Designed to grow with<br/> you—not around you</h3>
                            </div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="rentalRevoBottom">
                                <p>Rentid proudly supports a growing community of rental professionals 
                                driving innovation, solving industry-wide problems, and redefining 
                                rental excellence.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END rentalRevoMain */}


            {/* START letsBuildMain */}
            <section className='letsBuildMain'>
                <div className='container'>
                    <div className='row justify-content-center'>
                        <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                            <div className='letsBuildInner'>
                                <h2>Let’s Build the Future<br/> of Rentals—Together.</h2>
                                <p>Join the rental revolution with Rentid—where trust,<br/> growth, and innovation come standard.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END letsBuildMain */}


            {/* START howItStartedMain */}
            <section className='howItStartedMain'>
                <div className='container'>
                    <div className='howItStartedOuter'>
                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6">
                                <div className="howItStartedLeft">
                                    <figure>
                                        <img className='img-fluid' src="/img/About/howItStarted.webp" alt="How it started"/>
                                    </figure>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="howItStartedRight">
                                    <h2>How it started</h2>
                                    <p>“The idea for Rentid was born while working with independent car rental hosts on complex 
                                        insurance issues—while also living out of Airbnbs and renting cars as a guest. That mix 
                                        of supporting operators and experiencing the gaps firsthand made it clear: trust, 
                                        automation, and scalable tools were missing. No one was building true operator-first 
                                        solutions.”</p>
                                    <h4>Vishaal Pandya</h4>
                                    <small>Founder, CEO</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END howItStartedMain */}


            {/* STRAT landing-platform */}
            <section className='popularTopicsAnounceMain landing-platform'>
                <div className='container'>
                    {/* row start */}
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="popularTopicsAnounceHeading">
                                <h2>The Platform That Keeps Rentals Running</h2>
                            </div>
                        </div>
                    </div>
                    {/* row end */}

                    {/* row start */}
                    <div className="row justify-content-center">
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/direct.svg" alt="rent direct"/>
                                    <h4><span>rent</span>direct</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>Smart Booking Management</h3>
                                    <p>All-in-one booking system connected to a suite of rental workflows & tools unlike any other.</p>
                                    <a href="/rentdirect" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/shield.svg" alt="rent shield"/>
                                    <h4><span>rent</span>shield</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>Embedded Protection When Needed</h3>
                                    <p>Choose flexible insurance coverages and roadside assistance that turns on when the car goes out.</p>
                                    <a href="/rentshield" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/id.svg" alt="rent id"/>
                                    <h4><span>rent</span>id</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>Verify Every Guest, Instantly</h3>
                                    <p>Screen renters in seconds with ID, license, insurance checks and renter scoring.  </p>
                                    <a href="/rent-id" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/ai.svg" alt="rent ai"/>
                                    <h4><span>rent</span>ai</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>AI Rental Task Agent</h3>
                                    <p>AI rental agent that completes tasks, solves problems, & gets things done for your business. </p>
                                    <a href="/rentai" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/success.svg" alt="rent success"/>
                                    <h4><span>rent</span>success</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>Built-In Support & Resolution Center</h3>
                                    <p>Dedicated support, real-time rental resolutions, and a focus on lasting customer loyalty.</p>
                                    <a href="/rentsuccess" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                            <div className="popularTopicsAnounceInner">
                                <figure>
                                    <img className="img-fluid" src="/img/academy.svg" alt="rent academy"/>
                                    <h4><span>rent</span>academy</h4>
                                </figure>
                                <div className="popularDataAnounce">
                                    <h3>On Demand Industry Education </h3>
                                    <p>Where experts drop knowledge & growth strategies on podcasts, articles, and video series,</p>
                                    <a href="/rentacademy" className="btn">
                                        <span>Learn more</span>
                                        <img src="/img/arrow_spl.svg" alt="icon"/>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* row end */}

                </div>
            </section>
            {/* END landing-platform */}


            <section className="socialAreaMain">
                <div className="container">
                    <div className="row"> 
                            <div className="socialAreaInner">
                                <h2>Let’s get social</h2>
                                <ul>
                                    <li>
                                        <a href="https://www.facebook.com/profile.php?id=100087781668300" target="_blank" rel="noreferrer">
                                            <img className="img-fluid" src="/img/facebook.svg" alt="fb" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/rentid.io/" target="_blank" rel="noreferrer">
                                            <img className="img-fluid" src="/img/insta.svg" alt="instagram" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.linkedin.com/company/rentidinc/" target="_blank"rel="noreferrer" >
                                            <img className="img-fluid" src="/img/linkdin.svg" alt="linkdin" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://x.com/Rentid_" target="_blank" rel="noreferrer" >
                                            <img className="img-fluid" src="/img/twitter.svg" alt="twitter" />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                     
                    </div>
                </div>
            </section>

            <Footer/>
        </>
    )
}

export default About;